

export const genLocaleKeyForTextString = text => text.trim().toLowerCase().split(' ').join('')